export default __webpack_public_path__ + "static/media/notify.4342337e.svg";